import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserHistory } from 'history';
import { datadogLogs } from '@datadog/browser-logs';

import CssBaseline from '@material-ui/core/CssBaseline';

import config from 'config';
import ErrorSnackbar from './components/ErrorSnackbar';
import NeedPaymentSnackbar from './components/NeedPaymentSnackbar';
import CookieBanner from './components/CookieBanner';
import AppRoutes from './AppRoutes';

datadogLogs.init({
  clientToken: config.DATADOG_CLIENT_TOKEN,
  service: 'frontend-client',
  env: config.ENV_LABEL,
  forwardErrorsToLogs: true,
  sampleRate: 100,
});

export const history = createBrowserHistory();

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
        <div className="App">
          <CssBaseline />
          <AppRoutes />
          <ErrorSnackbar />
          <NeedPaymentSnackbar />
          <CookieBanner />
        </div>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
